import React from 'react';

import './Section.css';

const Section = ({ children, title }) => (
  <div className="Section">
    <div className="Section-title">
      <span>{title}</span>
    </div>
    <div className="Section-content">{children}</div>
  </div>
);

export default Section;



// WEBPACK FOOTER //
// ./src/components/basic/section/Section.js